export class ImagingProjectReadingBasicComponent {
  public static clearFocus(): void {
    document.activeElement['blur']();
  }
}
